
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Calendar, Clock } from 'lucide-react';
import { 
  SidebarGroup, 
  SidebarGroupContent, 
  SidebarGroupLabel, 
  SidebarMenu, 
  SidebarMenuItem, 
  SidebarMenuButton 
} from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';
import ROUTES from '@/routes-map';

const AppointmentsGroup: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Appointments & Scheduling</SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.APPOINTMENTS) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.APPOINTMENTS}>
                <Calendar className="h-5 w-5" />
                <span>Appointments</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.AVAILABILITY) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.AVAILABILITY}>
                <Clock className="h-5 w-5" />
                <span>Availability Settings</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};

export default AppointmentsGroup;
